<template>
    <div>

        <card class="h-100 my-0">

            <template slot="header" v-if="showHeader">
                <h4 class="card-title">{{campo.titulo}}</h4>
            </template>

            <b-row class="lista-local-prestacao-servico m-0 p-0">

                <div class="col-md-12 m-0 p-0">

                    <b-card class="mt-0 mb-2" v-for="(local,indexLocal) in campo.locaisPrestacaoServico" :key="local.id" no-body>

                        <b-card-header header-tag="header" class="d-flex justify-content-between align-items-center p-1" role="tab">
                            <span class="text-left text-truncate px-2" variant="primary">{{gerarHeaderLocal(local) }}</span>
                            <b-button v-if="showExcluir" variant="danger" size="sm" @click="excluir(local.id)">
                            <i class="fa fa-trash"></i>
                            </b-button>
                        </b-card-header>

                        <b-card-body>
                            <LocalPrestacaoServico :local="local" 
                                :leitura="leitura" :campo="campo" 
                                @cancelar="(e) => { cancelar(e) }"  />
                        </b-card-body>
                    </b-card>

                </div>

            </b-row>

            <b-row class="m-0 p-0">                
                <b-col class="text-center text-md-left m-0 p-0" cols="4" v-if="!leitura && !campo.naoQueroInformar">
                    <b-button v-if="!atingiuLimiteLocal(campo)" type="submit" class="btn btn-primary btn-fill" @click.prevent="incluir">
                        {{ campo.locaisPrestacaoServico.length == 0 ? 'Informar um local de prestação de serviço' : 'Informar mais um local de prestação de serviço'}}
                    </b-button>
                    <span v-else class="text-warning">{{ 'É possível informar até ' + campo.conf.quantidadeMaxima + ' locais.' }}</span>
                </b-col>
                <b-col class="d-flex align-items-center" v-if="exibirNaoQueroInformar(campo)">                    
                    <b-form-checkbox v-model="campo.naoQueroInformar" :disabled="leitura">{{ campo.conf && campo.conf.tituloNaoInformar ? campo.conf.tituloNaoInformar : "Não estou em um local ainda" }}</b-form-checkbox>
                </b-col>
            </b-row>

        </card>

    </div>

</template>

<script>

import Card from 'src/components/Cards/Card.vue';
import Confirma from './Confirma';
import LocalPrestacaoServico from './LocalPrestacaoServico.vue';

export default {
    props: ['showHeader', 'showSave', 'showExcluir', 'leitura', 'fluid', 'campo'],
    components: {
        Card,
        Confirma,
        LocalPrestacaoServico,
    },
    data() {
        return {
            show: false,
                showFrom: "",
            filaShow: [],
            id: null,
            fileSelecionado: null,
            copia: null,
            optionsUF: [],
        }
    },
    computed: {

    },
    mounted() {
        this.inicializar()
    },
    methods: {
        inicializar() {

        },                
        incluir() {

            let minId = this.campo.locaisPrestacaoServico.reduce(
                (min, loc) => (loc.id < min ? loc.id : min),
                0
            )

            minId -= 1;

            this.campo.locaisPrestacaoServico.push({
                "id": minId,
                "local": '',
                "outroLocal": '',
                "setor": '',
                "outroSetor": '',
                "nomeCoordenador": ''
            })
        },        
        gerarHeaderLocal(obj) {            
            var str = ''
            if (obj.local) {
                str += obj.local === '#outro#' ? obj.outroLocal : obj.local
            }                       
            if (obj.setor) {
                str += (str ? ' - ' : '') + (obj.setor === '#outro#' ? obj.outroSetor : obj.setor)
            }
            return str
        },
        atingiuLimiteLocal(obj){
            const quantMax = obj.conf && obj.conf.quantidadeMaxima ? obj.conf.quantidadeMaxima : 0
            return quantMax > 0 && obj.locaisPrestacaoServico.length >= quantMax;
        },
        exibirNaoQueroInformar(obj){
            const quantMin = obj.conf && obj.conf.quantidadeMinima ? obj.conf.quantidadeMinima : 0             
            return obj.locaisPrestacaoServico.length == 0 && quantMin === 0 ;
        },
        excluir(id) {
            this.campo.locaisPrestacaoServico = this.campo.locaisPrestacaoServico.filter((e) => { return e.id !== id })
        }        
    },
}

function dateToStr(date, format) {
    if (date !== undefined && date !== null) {
        let strDate = format
            .replace("yyyy", date.getFullYear())
            .replace("MM", (date.getMonth() + 1).toString().padStart(2, "0"))
            .replace("dd", date.getDate().toString().padStart(2, "0"))
            .replace("HH", date.getHours().toString().padStart(2, "0"))
            .replace("mm", date.getMinutes().toString().padStart(2, "0"))
            .replace("ss", date.getSeconds().toString().padStart(2, "0"));
        return strDate;
    }
    return "";
}

</script>
<style>

</style>